import { stringify } from "qs";
import { NextRouter } from "next/router";
import { clone } from "./ObjectUtil";
import { sanitizePassportNameInput } from "./FormUtil";

export function preparePollHotelsParam(param: any): any {
  const submitParam: any = { ...param };
  if (submitParam.min_price && typeof submitParam.min_price === "string") {
    delete submitParam.min_price;
  }
  if (
    (submitParam.max_price && typeof submitParam.max_price === "string") ||
    submitParam.max_price === 0
  ) {
    delete submitParam.max_price;
  }
  if (!submitParam.min_rank || parseInt(submitParam.min_rank, 10) === 0) {
    delete submitParam.min_rank;
  }
  if (!submitParam.min_rating || parseInt(submitParam.min_rating, 10) === 0) {
    delete submitParam.min_rating;
  }
  if (!submitParam.bed_count || parseInt(submitParam.bed_count, 10) === 0) {
    delete submitParam.bed_count;
  }
  if (!submitParam.meal_type) {
    delete submitParam.meal_type;
  }
  if (!submitParam.view_type) {
    delete submitParam.view_type;
  }
  if (!submitParam.bed_types) {
    delete submitParam.bed_types;
  }
  if (!submitParam.rank) {
    delete submitParam.rank;
  }
  if (!submitParam.descending_region_ids) {
    delete submitParam.descending_region_ids;
  }
  if (!submitParam.sort_by) {
    delete submitParam.sort_by;
  }
  return submitParam;
}

export function updateHotelIndexUrl(param: any, router: NextRouter): void {
  let newUrl = `/hotels?${stringify(param, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  router.replace(newUrl, null, { shallow: true });
}

export function updateHotelShowUrl(param: any, router: NextRouter): void {
  let newUrl = `${location.pathname}?${stringify(param, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  router.replace(newUrl, null, { shallow: true });
}

export function getHotelGradeText(grade: number, t: any): string {
  if (grade > 0 && grade <= 5) {
    return t(`unit:grade${Math.ceil(grade)}`);
  }
  return "";
}

export const convertHotelReservationFormValuesToParams = (data: any) => {
  const params = clone(data);
  if (params.guests?.length > 0) {
    params.guests = params.guests.map((guest) => {
      const newGuest = { ...guest };
      newGuest.first_name = sanitizePassportNameInput(newGuest.first_name);
      newGuest.last_name = sanitizePassportNameInput(newGuest.last_name);
      return newGuest;
    });
  }

  return params;
};
